import { BmCalcType, BmDataFillingType } from "./bm-enums";
import { LocalDate } from "../../../../core/component/pojo/date-variable";

export class BudgetModelWrapperDTO {
  selectedModel: BudgetModel;
  selectorData: BudgetModelSelectorMiniDTO[];
  analyticsData: BmAnalyticsData;
}
/**
 * Contains main model data for models selector
 */
export class BudgetModelMiniDTO {
  uuid: string;
  orgUuid: string;
  name: string;
  lastModifiedDate: Date;
  createdDate: Date;
  createdBy: string;
}

export class BudgetModelSelectorMiniDTO extends BudgetModelMiniDTO {
  selectorText: string;
}

export class BudgetModel {
  uuid: string;
  orgUuid: string;
  name: string;
  totalCommitment: number;
  yearsNumber: number;
  lastModifiedDate: Date;
  createdDate: Date;
  createdBy: string;
  modelData: BudgetModelData;
}

export class BudgetModelData {
  mgmFee: BmMgmFeeGroup[];
  operatingExpenses: BmExpGroup[];
  organizationalExpenses: BmExpGroup[];
  investment: BudgetModelInvestment;
}

export class BmPeriod {
  type: BmPeriodEnum;
  quarterNumber: number;
  yearNumber: number;
}

export enum BmPeriodEnum {
  QUARTER = 'QUARTER',
  YEAR = 'YEAR',
}

export class BmMgmFeeGroup {
  uuid: string;
  name: string;
  priority: number;
  subGroups: BmMgmFeeSubGroupWrapper;
}

export class BmMgmFeeSubGroupWrapper {
  commitment: BmMgmFeeCommitment;
  mgmFeesPcnt: BmMgmFeePcnt;
  pcntOfMgmFees: BmPcntOfMgmFee;
  vatPcnt: BmMgmFeeVatPcnt;
  isCatchUpSelected: boolean;
}


export class BmMgmFeeCommitment {
  standardValue: number;
  items: BmItem[];
}

export class BmMgmFeePcnt {
  standardValue: number;
  items: BmItem[];
}

export class BmPcntOfMgmFee {
  isSelected: boolean;
  standardValue: number;
  items: BmItem[];
}
export class BmMgmFeeVatPcnt {
  isSelected: boolean;
  standardValue: number;
  items: BmItem[];
}

export class BmItem {
  uuid: string;
  period: BmPeriod;
  itemValue: number;
  calcType: BmCalcType;

  static create(value: number, year: number, quarter: number | null): BmItem {
    return {
      uuid: null,
      period: {
        type: quarter ? BmPeriodEnum.QUARTER : BmPeriodEnum.YEAR,
        yearNumber: year,
        quarterNumber: quarter,
      },
      itemValue: value,
      calcType: BmCalcType.GENERATED,
    };
  }
}

export interface BmExpGroup {
  uuid: string;
  name: string;
  priority: number;
  dataFillingType: BmDataFillingType; // YEARLY, QUARTERLY, MONTHLY, MANUAL
  standardValue: number;
  items: BmItem[];
}

export class BudgetModelInvestment {
  uuid: string;
  investmentValue: number;
  itemsPcnt: BmItem[];
  itemsValue: BmItem[];
}

export class BmHeaderShow {
  modalThinkTwice = false;
}

export class BmAnalyticsData {
  selectedFund: BmFundMiniDTO;
  selectedPeriod: LocalDate;
  selectorsData: BmAnalyticsSelectorData[];
  selectedPeriodData: BmFundActualAnalytics;
  allPeriodsData: BmFundActualAnalytics[];
}

export class BmAnalyticsSelectorData {
  fund: BmFundMiniDTO;
  periods: LocalDate[];
}

export class BmFundMiniDTO {
  uuid: string;
  name: string;
  initialClosing: LocalDate;
}

export class BmFundActualAnalytics {
  period: LocalDate;
  capRequired: number;
  totalExp: number;
  investment: number;
  mgmFee: number;
  opExp: number;
  orgExp: number;
}

export type BmExpensesType = 'operatingExpenses' | 'organizationalExpenses';
export type BmTotalType = "totalCapRequired" | "totalCapAccumulated" | "totalExpenses";

